import styled from "styled-components";

export const BillDividerWrapper = styled.div(({ theme }) => ({
    borderTop: `1px dashed ${theme.colors[theme.colorMode].border_Subtle_Secondary}`,
}));
